module.exports = __webpack_public_path__ + "img/Alien_symbol_4.58fb55db.png";